import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M5.07305 11.5632C6.51838 11.5632 7.69005 10.409 7.69005 8.98523C7.69005 7.56144 6.51838 6.40723 5.07305 6.40723C3.62773 6.40723 2.45605 7.56144 2.45605 8.98523C2.45605 10.409 3.62773 11.5632 5.07305 11.5632Z"
      stroke={props.stroke || 'white'}
    />
    <path
      d="M11.0321 10.1324L2.2181 7.39625C0.342014 6.81386 0.342014 4.15846 2.2181 3.57607L11.0321 0.839996C11.2241 0.780394 11.4294 0.734834 11.6203 0.798081C13.7132 1.49172 13.7132 9.4806 11.6203 10.1743C11.4294 10.2375 11.2241 10.192 11.0321 10.1324Z"
      fill={props.fill || '#070F21'}
      stroke={props.stroke || 'white'}
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const MegaPhoneIcon = memo(ForwardRef);
export default MegaPhoneIcon;
